import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CONTACT } from "./Reveal";

const HERO_IMG =
  "https://images.unsplash.com/photo-1688494930045-328d0f95efe9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGNvbnN1bHRpbmclMjBwcm9mZXNzaW9uYWwlMjBhYnN0cmFjdCUyMGRhcmt8ZW58MHx8fHwxNzg2MDkxNDM4fDA&ixlib=rb-4.1.0&q=85";

const line = {
  hidden: { y: "110%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 1, delay: 0.25 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

function MaskLine({ children, i }) {
  return (
    <span className="block overflow-hidden">
      <motion.span variants={line} custom={i} initial="hidden" animate="show" className="block">
        {children}
      </motion.span>
    </span>
  );
}

export default function Hero({ onCta }) {
  return (
    <section id="top" className="relative min-h-screen flex items-end overflow-hidden">
      {/* Parallax abstract image */}
      <motion.div
        initial={{ scale: 1.15, opacity: 0 }}
        animate={{ scale: 1, opacity: 0.55 }}
        transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        className="absolute inset-0 z-0"
      >
        <img src={HERO_IMG} alt="" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-background/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-background/80 to-transparent" />
      </motion.div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-8 pb-20 pt-36">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.15, duration: 1 }}
          className="text-xs md:text-sm tracking-[0.35em] uppercase text-accent mb-8"
        >
          Digital Marketing & Consulting — London, UK
        </motion.p>

        <h1 className="font-display font-medium tracking-tight leading-[0.94] text-5xl sm:text-7xl lg:text-[7.5rem]">
          <MaskLine i={0}>Growth,</MaskLine>
          <MaskLine i={1}>
            <span className="italic">engineered</span> with
          </MaskLine>
          <MaskLine i={2}>
            <span className="text-accent">precision.</span>
          </MaskLine>
        </h1>

        <div className="mt-12 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 1 }}
            className="max-w-md text-base md:text-lg text-muted-foreground leading-relaxed"
          >
            {CONTACT.company} builds brands that command attention — strategy,
            advertising and content for ambitious companies across the UK and beyond.
          </motion.p>

          <motion.button
            data-testid="hero-cta"
            onClick={onCta}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.15, duration: 1 }}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
            className="group inline-flex items-center gap-3 self-start rounded-full bg-primary text-primary-foreground pl-7 pr-3 py-3 text-sm font-medium"
          >
            Let's build together
            <span className="grid place-items-center h-9 w-9 rounded-full bg-accent text-accent-foreground transition-transform group-hover:rotate-45">
              <ArrowUpRight size={18} />
            </span>
          </motion.button>
        </div>
      </div>
    </section>
  );
}
